// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3qnee","dragIcon":"SortableItem_dragIcon__3fi4V","disabled":"SortableItem_disabled__1hqBl"};